import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PreventScrollDirective } from '../../../directives/prevent-scroll.directive';

@Component({
    selector: 'app-language-confirm-modal',
    standalone: true,
    imports: [CommonModule, TranslateModule, PreventScrollDirective],
    templateUrl: './language-confirm-modal.html',
})
export class LanguageConfirmModal {
    @Input() selectedLanguageName: string = '';
    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();
}
